// 2P AI — tempo relativo in italiano per le righe sessione, e "è di oggi?" per il conteggio
// "Sessioni oggi" (che l'API /status non aggrega).
export function ago(iso: string | null): string {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const s = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (s < 45) return 'ora';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} h`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'ieri';
  if (d < 7) return `${d} g`;
  const w = Math.floor(d / 7);
  if (w < 5) return `${w} sett`;
  const mo = Math.floor(d / 30);
  if (mo < 12) return `${mo} mesi`;
  return `${Math.floor(d / 365)} anni`;
}

export function isToday(iso: string | null): boolean {
  if (!iso) return false;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return false;
  const now = new Date();
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
}
